<ui-tab-group [tabConfig]="tabs()"></ui-tab-group>

